import React from 'react';
import styled from 'styled-components';

const UnstyledLink = ({ children, ...props }) => {
    const StyledUnstyledLink = styled.a`
        color: inherit;
        border: none;
        
        &:active,
        &:hover,
        &:visited {
          color: inherit;
          text-decoration: none;
          border: none;
        }
        
    `;

    return (
        <StyledUnstyledLink {...props} >
            {children}
        </StyledUnstyledLink>
    );
};

export default UnstyledLink;



// WEBPACK FOOTER //
// ./src/components/styles/UnstyledLink.js